import i18next from "i18next";
import { RES_AFREECATV } from "constant/config";

export const AWARD = "AWARD";

//메달 이미지 다국어 대응
export const getBasicMedalImg = (lang,medalName) => {
    return RES_AFREECATV+"/images/medal/basic/lang/"+medalName.toLowerCase()+".svg";
}

//메달 이미지 다국어 대응
export const getSimpleMedalImg = (lang,medalName) => {
    return RES_AFREECATV+"/images/medal/simple/lang/"+medalName.toLowerCase()+".png";
}

export const getMedalDescription = (medalName,medalDescription) => {
    if(medalName.includes(AWARD)){
        const AWARD_YEAR = medalName.split('AWARD')[1].slice(0,4);//수상년도 추출

        return i18next.t("{{award_year}}Năm Ánh sáng BJ Mục tiêu Giải thưởng BJkhông thấy.",{award_year : AWARD_YEAR});
    }
    return i18next.t(medalDescription);
}

export const getMedalName = (medalName) => {
    if(medalName.includes("Mục tiêu BJ")){
        const AWARD_YEARd = medalName.slice(0,4);//수상년도 추출

        return i18next.t("{{award_year}} BJ Mục tiêu BJ",{award_year : AWARD_YEARd});
    }
    return i18next.t(medalName);
}